"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootReducer = void 0;
const redux_1 = require("redux");
const CurrentToolDuck_1 = require("../Ducks/CurrentToolDuck");
const ProjectionOpenDuck_1 = require("../Ducks/ProjectionOpenDuck");
const HighlightedSequenceDuck_1 = require("../Ducks/HighlightedSequenceDuck");
const DatasetDuck_1 = require("../Ducks/DatasetDuck");
const OpenTabDuck_1 = require("../Ducks/OpenTabDuck");
const WebGLViewDuck_1 = require("../Ducks/WebGLViewDuck");
const ClusterModeDuck_1 = require("../Ducks/ClusterModeDuck");
const AdvancedColoringSelectionDuck_1 = require("../Ducks/AdvancedColoringSelectionDuck");
const ProjectionColumnsDuck_1 = require("../Ducks/ProjectionColumnsDuck");
const DisplayModeDuck_1 = require("../Ducks/DisplayModeDuck");
const LineBrightnessDuck_1 = require("../Ducks/LineBrightnessDuck");
const ActiveLineDuck_1 = require("../Ducks/ActiveLineDuck");
const StoriesDuck_1 = require("../Ducks/StoriesDuck");
const StoryModeDuck_1 = require("../Ducks/StoryModeDuck");
const AggregationDuck_1 = require("../Ducks/AggregationDuck");
const SelectedClustersDuck_1 = require("../Ducks/SelectedClustersDuck");
const ViewTransformDuck_1 = require("../Ducks/ViewTransformDuck");
const CurrentClustersDuck_1 = require("../Ducks/CurrentClustersDuck");
const ProjectionParamsDuck_1 = require("../Ducks/ProjectionParamsDuck");
const CheckedShapesDuck_1 = require("../Ducks/CheckedShapesDuck");
const ProjectionWorkerDuck_1 = require("../Ducks/ProjectionWorkerDuck");
const VectorByShapeDuck_1 = require("../Ducks/VectorByShapeDuck");
const ClusterEdgesDuck_1 = require("../Ducks/ClusterEdgesDuck");
const SelectedVectorByShapeDuck_1 = require("../Ducks/SelectedVectorByShapeDuck");
const PathLengthRange_1 = require("../Ducks/PathLengthRange");
const CategoryOptionsDuck_1 = require("../Ducks/CategoryOptionsDuck");
const ChannelSize_1 = require("../Ducks/ChannelSize");
const ChannelColorDuck_1 = require("../Ducks/ChannelColorDuck");
const GlobalPointSizeDuck_1 = require("../Ducks/GlobalPointSizeDuck");
const HoverStateDuck_1 = require("../Ducks/HoverStateDuck");
const PointColorScaleDuck_1 = require("../Ducks/PointColorScaleDuck");
const PointColorMappingDuck_1 = require("../Ducks/PointColorMappingDuck");
const TrailSettingsDuck_1 = require("../Ducks/TrailSettingsDuck");
const StoryEditorDuck_1 = require("../Ducks/StoryEditorDuck");
const allReducers = {
    currentTool: CurrentToolDuck_1.default,
    currentAggregation: AggregationDuck_1.default,
    stories: StoriesDuck_1.default,
    currentClusters: CurrentClustersDuck_1.default,
    openTab: OpenTabDuck_1.default,
    clusterEdges: ClusterEdgesDuck_1.default,
    selectedVectorByShape: SelectedVectorByShapeDuck_1.default,
    vectorByShape: VectorByShapeDuck_1.default,
    checkedShapes: CheckedShapesDuck_1.default,
    activeLine: ActiveLineDuck_1.default,
    dataset: DatasetDuck_1.default,
    highlightedSequence: HighlightedSequenceDuck_1.default,
    viewTransform: ViewTransformDuck_1.viewTransform,
    advancedColoringSelection: AdvancedColoringSelectionDuck_1.default,
    storyMode: StoryModeDuck_1.default,
    projectionColumns: ProjectionColumnsDuck_1.default,
    projectionOpen: ProjectionOpenDuck_1.default,
    projectionParams: ProjectionParamsDuck_1.default,
    projectionWorker: ProjectionWorkerDuck_1.default,
    webGLView: WebGLViewDuck_1.default,
    clusterMode: ClusterModeDuck_1.default,
    selectedClusters: SelectedClustersDuck_1.default,
    displayMode: DisplayModeDuck_1.default,
    lineBrightness: LineBrightnessDuck_1.default,
    pathLengthRange: PathLengthRange_1.default,
    categoryOptions: CategoryOptionsDuck_1.default,
    channelSize: ChannelSize_1.default,
    channelColor: ChannelColorDuck_1.default,
    globalPointSize: GlobalPointSizeDuck_1.default,
    hoverState: HoverStateDuck_1.default,
    pointColorScale: PointColorScaleDuck_1.default,
    pointColorMapping: PointColorMappingDuck_1.default,
    trailSettings: TrailSettingsDuck_1.default,
    storyEditor: StoryEditorDuck_1.default
};
const appReducer = redux_1.combineReducers(allReducers);
exports.rootReducer = (state, action) => {
    if (action.type === 'RESET_APP') {
        const { dataset, openTab, viewTransform, webGLView } = state;
        state = { dataset, openTab, viewTransform, webGLView };
    }
    return appReducer(state, action);
};
const rootReducer2 = redux_1.combineReducers({
    dataset: DatasetDuck_1.default
});
let r = null;
